// This creates a global "Event Bus" that can be used for sibling components to pass events back and forth.
import Vue from 'vue';
export default new Vue();